export function calculatePercentageOf(value: number = 0, total = 1): number {
  return (value * 100) / total;
}

export function toPercentage(value: number): string {
  return `${value.toFixed(2)}%`;
}

export function formatCurrency(value: number, currency = "EUR"): string {
  return Intl.NumberFormat("es-ES", {
    style: "currency",
    currency,
  }).format(value);
}
